import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Button from '../Button';

const viewportConfig = { 
  threshold: 0.1,
  triggerOnce: false,
  rootMargin: "-50px 0px"
};

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const ContactCTA = () => {
  const [ref, inView] = useInView(viewportConfig);
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start(inView ? "visible" : "hidden");
  }, [controls, inView]);

  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
      sx={{ 
        
        backgroundColor: '#F7F9FC',
        width: '100%',
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 4 }
      }}
    >
      <Box sx={{ 
        maxWidth: '1200px',
        mx: 'auto',
        width: '100%'
      }}>
        <Box
          component={motion.div}
          variants={itemVariants}
          sx={{
            backgroundColor: '#64B5F6',
            borderRadius: '16px',
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
              zIndex: 1
            }
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 'bold',
              mb: 3,
              position: 'relative',
              zIndex: 2,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
            }}
          >
            Are you satisfied with our process?
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              mb: 4,
              opacity: 0.9,
              position: 'relative',
              zIndex: 2,
              maxWidth: '600px',
              mx: 'auto'
            }}
          >
            Connect with us OR JUST EMAIL US, we will respond as soon as we can.
          </Typography>
          <Box 
            sx={{ 
              position: 'relative', 
              zIndex: 2,
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}
          >
            <Button 
              variant="dark" 
              href="https://www.mymortgageline.ca/contact/"  
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Get a mortgage quote from Mortgage Line"
            >
              Get a Quote
            </Button>
            <Button
              component={motion(Link)}
              to="/Contact"
              variant="primary"
              aria-label="Contact Mortgage Line for assistance"
            >
              Contact Us
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactCTA; 